/**
 * Returns the API base URL.
 * - If NEXT_PUBLIC_API_URL is set → use it (mostly SSR / dev).
 * - Otherwise → use the current origin (same-host via nginx). Falls back
 *   to an empty string during SSR when `window` is unavailable; consumers
 *   that run on the server should pass an explicit base URL instead.
 */
export function getApiBaseUrl(): string {
  if (process.env.NEXT_PUBLIC_API_URL) return process.env.NEXT_PUBLIC_API_URL;
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}
